import { GetUserTasksResponse, UpdateUserTaskResponse } from './types';

// Shared mock task object to avoid duplication
const mockTask = {
  id: 'task-1',
  name: 'Review Document Classification',
  status: 'open' as const,
  priority: 'high' as const,
  targetCompletionDate: new Date('2024-12-31'),
  assignedToUserId: 'user-1',
  documentId: 'doc-1',
  extractedDataId: 'ext-1',
  comment:
    'This task requires special attention to the income verification section.',
  createdAt: new Date('2024-12-01'),
  updatedAt: new Date('2024-12-01'),
  isDeleted: false,
  document: {
    documentType: {
      id: 'doc-1',
      name: 'Tax Return 2023.pdf',
      displayName: 'Tax Return',
    },
  },
  extractedData: {
    id: 'ext-1',
    fieldType: {
      displayName: 'Annual Income',
      documentTypeId: 'doc-type-1',
    },
    initialValue: '$75,000',
    fieldConfidence: 85,
  },
};

// Mock data for getUserTasks
export const mockGetUserTasksResponse: GetUserTasksResponse = {
  success: true,
  tasks: [{ ...mockTask, isMapped: true }],
  nextCursor: undefined,
};

// Mock data for updateUserTask
export const mockUpdateUserTaskResponse: UpdateUserTaskResponse = {
  success: true,
  userTask: {
    ...mockTask,
    status: 'In Progress',
    priority: 'High',
    updatedAt: new Date('2024-12-15'),
  },
  tasks: [
    {
      id: 'task-1',
      success: 'success',
    },
  ],
};
